const AccordionToggleAllButton = (accordion) => {
  const toggleAllButton = accordion.querySelector(
    '[data-accordion-toggle-all-button]'
  );
  const accordionItems = accordion.querySelectorAll('[data-accordion-item]');
  const isFullyExpanded = () =>
    Array.from(accordionItems).every(
      (accordionItem) =>
        !accordionItem.children[0].className.includes('collapsed')
    );
  const renderToggleAllButtonText = () => {
    toggleAllButton.innerHTML = isFullyExpanded()
      ? 'Collapse all'
      : 'Expand all';
  };

  renderToggleAllButtonText();

  accordionItems.forEach((accordionItem) => {
    accordionItem.children[0].addEventListener('click', (e) => {
      renderToggleAllButtonText();
      if (e.isTrusted) {
        document.location.hash = `#${e.target.id}`;
      }
    });
  });

  toggleAllButton.addEventListener('click', () => {
    if (isFullyExpanded()) {
      accordionItems.forEach((accordionItem) => {
        accordionItem.children[0].click();
      });
    } else {
      accordionItems.forEach((accordionItem) => {
        if (accordionItem.children[0].className.includes('collapsed')) {
          accordionItem.children[0].click();
        }
      });
    }
    renderToggleAllButtonText();
  });
};

document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('[data-accordions]');

  if (accordions.length) {
    accordions.forEach((accordion) => AccordionToggleAllButton(accordion));
  }

  const anchor = window.location.hash.substring(1);
  if (anchor.startsWith('accordion-')) {
    document.getElementById(anchor)?.click();
  }
});
